/* eslint-disable */
const init = () => {

    /**
     * File navigation.js.
     *
     * Handles toggling the navigation menu for small screens and enables TAB key
     * navigation support for dropdown menus.
     */
    let i, len;

    const container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    const mainMenu = document.getElementById('menu-main-menu');

    if ('undefined' === typeof mainMenu) {
        return;
    }


    // Get all the link elements within the menu.
    const links = mainMenu.getElementsByTagName('a');
    const subMenus = mainMenu.getElementsByTagName('ul');

    // Set menu items with submenus to aria-haspopup="true".
    for (i = 0, len = subMenus.length; i < len; i++) {
        subMenus[i].parentNode.setAttribute('aria-haspopup', 'true');
    }

    // toggle click on menu items with class .menu-item-has-children, and add class .open
    const menuItems = document.querySelectorAll('.menu-item-has-children > a[href="#"]');
    console.log(menuItems);
    menuItems.forEach((item) => {
        item.addEventListener('click', (event) => {
            event.preventDefault();
            item.parentNode.classList.toggle('open');
        });
    });

    // click anywhere outside of menu to close menu
    document.addEventListener('click', (event) => {
        const target = event.target;
        const isClickInside = container.contains(target);
        if (!isClickInside) {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');
            });
        }
    });

    // press escape key to close menu
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');
            });
        }
    });

};

export default init;
